import Styleguide, { Colors, theme } from "../../theme";
import styled from "styled-components";

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  gap: 16px;
  margin: 40px 0px 24px;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    margin: 16px 0px;
  }
`;

export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  border: solid 1px ${theme(Colors.gray[300], Colors.gray[200])};
  border-radius: 8px;
  padding: 0px 12px;
  outline: none;
  box-sizing: border-box;
  background: transparent;
  font-size: ${Styleguide.fontSizes[16]};
  color: ${theme(Colors.black, Colors.white)};

  &::placeholder {
    color: ${theme(Colors.gray[300], Colors.gray[200])};
    font-style: italic;
  }

  &:focus {
    border: 1px solid ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    height: 48px;
    font-size: ${Styleguide.fontSizes[18]};
  }
`;

export const TrailingIcon = styled.button`
  display: flex;
  position: absolute;
  right: 4px;
  cursor: pointer;
  fill: ${theme(Colors.gray[300], Colors.gray[200])};
  padding: 10px;
  border: none;
  border-radius: 50%;
  background: transparent;

  &:hover {
    background-color: ${theme(Colors.gray[100], Colors.gray[400])};
  }

  &:focus,
  &:active {
    outline: 1px solid ${theme(Colors.blue[100], Colors.lightBlue[100])};
    background-color: ${theme(Colors.gray[200], Colors.gray[300])};
  }
`;

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  top: 70px;
  border: 1px solid #d8d8d8;
  border-radius: 0px 0px 8px 8px;
  box-sizing: border -box;
  box-shadow: 0px 52px 80px rgba(0, 0, 0, 0.1),
    0px 11.6149px 17.869px rgba(0, 0, 0, 0.0596107),
    0px 3.45805px 5.32008px rgba(0, 0, 0, 0.0403893);
  background: #ffffff;
  overflow: hidden;
`;

export const ResultText = styled.div`
  display: flex;
  align-items: center;
  font-family: "opensans-regular";
  font-size: 14px;
  line-height: 18px;
  color: #333333;
  align-items: flex-start;
  padding: 16px;
  outline-color: #0669de;

  @media screen and (min-width: 650px) {
    padding: 16px 24px;
  }
`;

export const ProviderListContainer = styled.div`
  display: block;
  outline: none;
  border-radius: 0px 0px 8px 8px;

  &:focus {
    border: 1px solid #0669de;
  }
`;

export const ProviderNotFoundContainer = styled.div`
  display: block;
  padding: 0px 24px;
  outline: none;
  border-radius: 0px 0px 8px 8px;

  &:focus {
    border: 1px solid #0669de;
  }

  div {
    border-top: solid 1px #e6e6e6;
  }

  h3 {
    font-family: GlobotipoTexto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    margin: 16px 0px 8px 0px;
  }

  p {
    font-family: opensans-regular;
    font-size: 12px;
    color: #666666;
    margin: 8px 0px 24px 0px;
  }
`;

export const SearchResult = styled.p`
  color: ${theme(Colors.gray[500], Colors.white)};
  font-style: italic;
  margin: 0;
`;
